import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { Button } from "react-bootstrap";
import localization from 'assets/localization/localization';
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ListFilters from "components/sales/ListFilters/ListFilters";
import TagOrderCsvUpload from 'components/sales/bulkUpload/TagOrderCsvUpload';

const ToaTagOrders = ({
    getToaTagOrders,
    toaTagOrders = [],
    uploadTagOrderCsv
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFullfillStatus, setSelectedFullfillStatus] = useState(null);
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [bulkFile, setBulkFile] = useState(null);
  const [isUploaded, setIsuploaded] = useState(false);
  const [bulkError, setBulkError] = useState('');
  const [bulkLoading, setBulkLoading] = useState(false);
  const [showBulkCsv, setShowBulkCsv] = useState(false);

  const headers = [
    "Order Id",
    "Operator Id",
    "Requestor Name",
    "Phone",
    "Role",
    "Total Quantity",
    "Banks",
    "Status",
    "Creation Date",
    "Action",
  ];

  useEffect(() => {
    (async () => {
        try {
        setIsLoading(true);
        await getToaTagOrders(null, 1);
        } catch (error) {
        console.error("Error while fetching TOA Tag Orders list:", error);
        } finally {
        setIsLoading(false);
        }
    })();
  }, []);
  
  useEffect(() => {

    if (!toaTagOrders || !toaTagOrders?.results) return;
  
    let tableData = [];

      tableData = [
        "order_id",
        "operator_id",
        "requestor_name",
        "requestor_phone",
        "requestor_role",
        "quantity",
        "bank_list",
        "status",
        "date",
      ];

    const data = toaTagOrders.results.map((element) => {

      const requestorName = `${element.requestor?.first_name || ""} ${element.requestor?.last_name || ""}`.trim();
      const requestorPhone = element.requestor?.phone || "";
      const requestorRole = element.requestor?.role || "";
      const operatorId = element.requestor?.user_id || "";
      const bankList = element.banks?.length
        ? element.banks.join(", ")
        : "";

      let actions = [
        {
          name: 'View Details',
          link: `${baseUrl}/view-tag-order/${element.order_id}`,
        }
      ];

      // if (element.status == 'APPROVED') {
      //   actions.push({
      //     name: 'Upload CSV',
      //     link: '',
      //     id: element.order_id,
      //   });
      // }

      return {
        ...Object.fromEntries(tableData.map(key => [key, element[key]])),
        Action: actions,
        operator_id: operatorId,
        requestor_name: requestorName,
        requestor_phone: requestorPhone,
        requestor_role: requestorRole,
        bank_list: bankList,
      };
    });
  
    data && setListData(data);
    setPageCount(Math.ceil(toaTagOrders?.count / 30));
  
  }, [toaTagOrders]);     

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getToaTagOrders(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  // const downloadSampleCSV = () => {
  //   const csvContent = `barcode\r\n123456-789-0123456`;

  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", "sample.csv");

  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);

  //   URL.revokeObjectURL(url);
  // };

  const applyFilter = async (filterData) => {
    localStorage.setItem("tag_orders_filter", JSON.stringify(filterData));
    setListData([])
    setIsLoading(true);
    setFilterData(filterData);
    // console.log("Filter Data: " + JSON.stringify(filterData));
    await getToaTagOrders(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const handleModalHide = () => {
    setShowBulkCsv(false);
    setSelectedOrderId(null);
    setIsuploaded(false);
    setBulkFile(null);
    setBulkError('');
  };

  const headerBtns = () => {
    return (
      <>
        <Fragment>
          {/* <Button
            onClick={downloadSampleCSV}
            className="btn btn-primary"
          >
            {localization.downloadSampleCSV}
          </Button> */}
          <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.Filter} alt=""></img>
            {localization.showFilters}
          </Button>
        </Fragment>
      </>
    );
  };

  const handlebulkSubmit = async () => {
    if (bulkLoading) return;

    if (!bulkFile) {
      setBulkError('Please upload a CSV file');
      return;
    }

    if (!selectedOrderId) {
      setBulkError('Order ID missing. Please try again.');
      return;
    }

    try {
      setIsLoading(true);
      setBulkLoading(true);
      setBulkError('');

      const formData = new FormData();
      formData.append('csv_file', bulkFile);
      formData.append('order_id', selectedOrderId);

      const result = await uploadTagOrderCsv(formData);

      setIsuploaded(true);
    } catch (err) {
      setBulkError(err.message);
      setIsuploaded(false);
    } finally {
      setBulkLoading(false);
      setIsLoading(false);
    }
  };

  const handleFileChange = (file) => {
    setBulkFile(file);
    setBulkError('');
  };

  return (
    <>
        <Layout
        title="TOA Tag Orders"
        Buttons={headerBtns}
        className={false ? "requiredFileds" : ""}
        isLoading={isLoading}
        >
            <TableSection
                data={listData}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                setShowBulkCsv={setShowBulkCsv}
                setSelectedOrderId={setSelectedOrderId}
            />
            <TagOrderCsvUpload
              showBulkCsv={showBulkCsv}
              isUploaded={isUploaded}
              isSubmitting={bulkLoading}
              errorMessage={bulkError}
              selectedFile={bulkFile}
              selectedOrderId={selectedOrderId}
              handleFileChange={handleFileChange}
              handlebulkSubmit={handlebulkSubmit}
              handleModalHide={handleModalHide}
              redirectUrl="/toa-tag-orders"
            />
            <ListFilters
              showFilter={showFilter}
              filterToggle={filterToggle}
              applyFilter={(val) => applyFilter(val)}
              tagOrdersFilter
              listFilterData={toaTagOrders}
              setSelectedFullfillStatus={setSelectedFullfillStatus}
              setSelectedDateFrom={setSelectedDateFrom}
              setSelectedDateTo={setSelectedDateTo}
            />

        </Layout>
    </>
  );
};

export default ToaTagOrders;
